import * as Yup from "yup";

export interface IUserCreate {
  username: string,
  name: string,
  email: string,
}

export interface IResponseUserTO{
  id?: number,
  name?: string,
  email?: string,
  username?: string,
  status: EStatus,
}

export interface IRequestUserTO{
  name?: string,
  email?: string,
  username?: string,
  status?: EStatus,
}

export enum EStatus{
  // eslint-disable-next-line no-unused-vars
  ACTIVE= "ACTIVE", INACTIVE ="INACTIVE", PENDING = "PENDING", BLOCKED = "BLOCKED"
}

export enum EFilterColumnsUser {
  // eslint-disable-next-line no-unused-vars
  NAME = "Nome", EMAIL = "Email", USER = "Usuário", STATUS = "Status"
}

export const userCreateValidationSchema = Yup.object({
  username: Yup.string().required("Usuário : Campo obrigatório"),
  name: Yup.string().required("Nome : Campo obrigatório").min(3, "Nome : Mínimo de 3 caracteres"),
  email: Yup.string().required("Email : Campo obrigatório").email("Email : inválido"),
});
